import React from "react";
import { CCol, CContainer, CRow } from "@coreui/react";

import Header from "components/Header";
import Loader from "components/Loader";
import { useInlet } from "context/inletContext";

import Scanner from "./components/Scanner";
import Assistants from "./components/Assistants";
import { TheHeader } from "containers";

function Inlet() {
  const { showCamera } = useInlet();

  return (
    <>
      <TheHeader hideMenu />
      {showCamera ? (
        <Scanner />
      ) : (
        <>
          <CContainer>
            <CRow className="justify-content-center">
              <Header showFinish />
            </CRow>
            <CRow className="justify-content-center">
              <CCol xs="12" md="9" lg="7" xl="6">
                <Assistants />
              </CCol>
            </CRow>
          </CContainer>
        </>
      )}
    </>
  );
}

export default Loader((props) => props.loading)(Inlet);
